var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStockPurchase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.0356 9.2416L29.7076 11.1297V0H23.0828V11.1297L25.7548 9.2416C25.9418 9.10846 26.1656 9.03691 26.3952 9.03691C26.6247 9.03691 26.8486 9.10846 27.0356 9.2416Z",
    fill: "#19A7CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9785 36.4362H24.1868V44.1651H28.6033V36.4362H30.8116L26.3951 30.9155L21.9785 36.4362Z",
    fill: "#19A7CE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M48.4778 46.3736V22.0827C48.4778 21.7899 48.3614 21.509 48.1544 21.3019C47.9473 21.0949 47.6665 20.9785 47.3736 20.9785H40.7488V0H31.9158V13.2496C31.9162 13.4524 31.8608 13.6513 31.7556 13.8247C31.6504 13.998 31.4995 14.139 31.3195 14.2323C31.145 14.3177 30.9509 14.3556 30.7571 14.342C30.5632 14.3284 30.3763 14.2639 30.2154 14.155L26.3951 11.494L22.6189 14.155C22.4534 14.2729 22.2585 14.3428 22.0558 14.357C21.853 14.3712 21.6503 14.3292 21.4699 14.2356C21.2895 14.142 21.1385 14.0004 21.0334 13.8264C20.9283 13.6524 20.8733 13.4528 20.8744 13.2496V0H12.0413V20.9785H5.41654C5.1237 20.9785 4.84286 21.0949 4.6358 21.3019C4.42873 21.509 4.3124 21.7899 4.3124 22.0827V46.3736H1C1.04055 48.1698 1.79246 49.8765 3.09053 51.1187C4.3886 52.3608 6.12667 53.0369 7.92292 52.9984H44.8673C46.688 53.0093 48.4417 52.3125 49.7586 51.0552C50.399 50.4549 50.9096 49.7299 51.259 48.9247C51.6084 48.1196 51.7892 47.2514 51.7902 46.3736H48.4778ZM34.4773 46.3736V48.5819H18.3128V46.3736H6.52067V23.1868H12.0413V26.4992H40.7488V23.1868H46.2695V46.3736H34.4773Z",
    fill: "#146C94"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStockPurchase);
export default __webpack_public_path__ + "static/media/stock-purchase.84ef1f80c132bfc8bda802eab335c0b9.svg";
export { ForwardRef as ReactComponent };